<script>
  export default{
    name: "CpHomeRallyBanner",
    components : {
      CpBox : require('../box').default,
      CpBoxContent : require('../box-content').default,
      CpButton : require('../button').default,
      CpGrid : require('../grid').default,
      CpGridItem:require('../grid-item').default,
    }
  }
</script>

<template>
  <cp-grid>
    <cp-grid-item :span="$root.isMobile ? 0 : 2 "></cp-grid-item>
    <cp-grid-item :span="$root.isMobile ? 12 : 8 ">
      <cp-box>
        <cp-box-content>
          <header class="heading-1">
            Introducing The Virtual Campaign Rally
          </header>
          <img src="https://res.cloudinary.com/crowdpac/image/upload/v1584573943/crowdpac/virtual-rally.png" />
        </cp-box-content>
      </cp-box>
    </cp-grid-item>
    <cp-grid-item :span="$root.isMobile ? 0 : 2 "></cp-grid-item>
  </cp-grid>
</template>

<style>
</style>
